export default __webpack_public_path__ + "static/media/my-course-mobile.7f2c39bb.png";